export const getRuntimeEnvironment = () =>
    [
        'www.iwoca.co.uk',
        'www.iwoca.de',
        'edge.iwoca.co.uk',
        'edge.iwoca.de'
    ].includes(window.location.hostname)
        ? 'production'
        : 'staging';
